/* eslint-disable @typescript-eslint/no-explicit-any */
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { NgClass } from '@angular/common';

@Component({
  selector: 'app-cd-tabs-radio-button',
  templateUrl: './cd-tabs-radio-button.component.html',
  styleUrls: ['./cd-tabs-radio-button.component.scss'],
  imports: [NgClass],
})
export class CdTabsRadioButtonComponent implements OnInit {
  @Input() options: { label: string; value: any }[] = [];
  @Input() selectedValue?: any;
  @Output() selectedValueChange = new EventEmitter<any>();

  constructor() {}

  ngOnInit(): void {}

  onChange(value: any) {
    this.selectedValue = value;
    this.selectedValueChange.emit(this.selectedValue);
  }
}
